module.exports = __webpack_public_path__ + "img/open_in_browser_dark_24dp.19aefa0f.svg";